/**
 * MyCover.js
 *
 * This file contains all the route under My cover
 */

import View from '@/components/componentView.vue';
import { MY_COVER } from '@/constants/pageTitles';
// import RebateNomination from '@/views/RebateNomination/RebateNomination.vue';
import KeepMyCover from '@/views/MyCover/ChangeCover/ChangeProduct/KeepMyCover.vue';
import TaxStatements from '@/views/MyCover/TaxStatements.vue';
import Payments from '@/views/MyCover/Payments/Payments.vue';
import MyDocuments from '@/views/MyCover/MyDocuments/MyDocuments.vue';
import MakeAPayment from '@/views/MyCover/Payments/MakeAPayment.vue';
import PaymentSuccessful from '@/views/MyCover/Payments/PaymentSuccessful.vue';
import WaitingPeriod from '@/views/MyCover/WaitingPeriods/WaitingPeriod.vue';
import PremiumCalculator from '@/views/MyCover/PremiumCalculator/PremiumCalculator.vue';
import ChangeCoverLanding from '@/views/MyCover/ChangeCover/Landing.vue';
import ChangeProductHome from '@/views/MyCover/ChangeCover/ChangeProduct/Home.vue';
import ChangeProductCaptureInfo from '@/views/MyCover/ChangeCover/ChangeProduct/CaptureAdditionalInformation.vue';
import NewProductSelection from '@/views/MyCover/ChangeCover/ChangeProduct/NewProductSelection.vue';
import ChangeCoverConfirmation from '@/views/MyCover/ChangeCover/ChangeProduct/ChangeCoverConfirmation.vue';
import AddRemovePersonHome from '@/views/MyCover/ChangeCover/AddRemovePerson/Home.vue';
import AddRemovePersonSuccessConfirmation from '@/views/MyCover/ChangeCover/AddRemovePerson/SuccessConfirmation.vue';
import ChangeExcess from '@/views/MyCover/ChangeExcess/ChangeExcess.vue';
import ChangeExcessPremiumImpact from '@/views/MyCover/ChangeExcess/ChangeExcessPremiumImpact.vue';
import { RebateLanding, RebateTierHistory, AddRebate, UpdateRebate, RebateUpdated, WithdrawRebate } from '@/views/MyCover/Rebates';
import {
  HOME,
  MY_COVER_PAYMENTS,
  // MY_COVER_REBATE_NOMINATION,
  MY_COVER_TAX_STATEMENTS,
  MY_COVER_MY_DOCUMENTS,
  MY_COVER_MAKE_A_PAYMENT,
  MY_COVER_PAYMENTS_SUCCESSFUL,
  WAITING_PERIODS,
  MY_COVER_PREMIUM_CALCULATOR,
  CHANGE_MY_COVER,
  KEEP_MY_COVER,
  CHANGE_MY_PRODUCT,
  PRODUCT_SELECTION,
  CAPTURE_ADDITIONAL_INFORMATION,
  CHANGE_COVER_CONFIRMATION,
  ADD_REMOVE_PERSON,
  ADD_REMOVE_PERSON_SUCCESS,
  CHANGE_EXCESS,
  CHANGE_EXCESS_PREMIUM_IMPACT,
  REBATES_MEMBER_PORTAL,
} from './routeNames';
import { peekNavigationState, getNavigationState } from './navigationState';

const changeCoverRouterGuard = (to) => {
  if (peekNavigationState().isFromLandingPage) {
    return true;
  } else if (to.name === PRODUCT_SELECTION && to.query?.quoteId) {
    // Allow direct access to product selection when resuming via a quoteId link.
    // Returning a new location that resolves to the same route would cause an infinite redirect.
    return true;
  } else {
    return { name: CHANGE_MY_COVER, params: { policyNumber: to.params.policyNumber } };
  }
};

const rebatesRouterGuard = (to) => {
  if (peekNavigationState().isFromLandingPage) {
    return true;
  } else {
    return { name: REBATES_MEMBER_PORTAL.REBATE_OVERVIEW, params: { policyNumber: to.params.policyNumber } };
  }
};

export default [
  {
    path: 'my-cover',
    component: View,
    meta: {
      title: 'My cover',
      isCategory: true,
    },
    children: [
      {
        path: '',
        redirect: {
          name: HOME,
        },
      },
      // {
      //   path: 'rebate-nomination',
      //   component: View,
      //   meta: {
      //     title: MY_COVER.REBATE_NOMINATION.LANDING,
      //   },
      //   children: [
      //     {
      //       path: '',
      //       name: MY_COVER_REBATE_NOMINATION,
      //       component: RebateNomination,
      //       meta: {
      //         title: MY_COVER.REBATE_NOMINATION.LANDING,
      //       },
      //     },
      //     {
      //       path: 'update-rebate-tier',
      //       name: MY_COVER_UPDATE_REBATE_TIER,
      //       component: UpdateRebateTier,
      //       meta: {
      //         title: MY_COVER.REBATE_NOMINATION.UPDATE_TIER,
      //       },
      //     },
      //     {
      //       path: 'rebate-premium-impact',
      //       name: MY_COVER_REBATE_PREMIUM_IMPACT,
      //       component: RebatePremiumImpact,
      //       meta: {
      //         title: MY_COVER.REBATE_NOMINATION.PREMIUM_IMPACT,
      //       },
      //     },
      //   ],
      // },
      {
        path: 'payments',
        component: View,
        meta: {
          title: MY_COVER.PAYMENTS.LANDING,
        },
        children: [
          {
            path: '',
            name: MY_COVER_PAYMENTS,
            component: Payments,
            meta: {
              title: MY_COVER.PAYMENTS.LANDING,
            },
          },
          {
            path: 'make-a-payment',
            component: View,
            meta: {
              title: MY_COVER.PAYMENTS.MAKE_A_PAYMENT,
            },
            children: [
              {
                path: '',
                name: MY_COVER_MAKE_A_PAYMENT,
                component: MakeAPayment,
                props: () => getNavigationState(), // this is required so that the params passed via navigationState are passed to the component as props
                meta: {
                  title: MY_COVER.PAYMENTS.MAKE_A_PAYMENT,
                },
              },
              {
                path: 'payment-successful',
                name: MY_COVER_PAYMENTS_SUCCESSFUL,
                props: () => getNavigationState(),
                component: PaymentSuccessful,
                meta: {
                  title: MY_COVER.PAYMENTS.PAYMENT_SUCCESSFUL,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'tax-statements',
        name: MY_COVER_TAX_STATEMENTS,
        component: TaxStatements,
        meta: {
          title: MY_COVER.TAX_STATEMENTS.LANDING,
        },
      },
      {
        path: 'premium-calculator',
        component: PremiumCalculator,
        name: MY_COVER_PREMIUM_CALCULATOR,
        meta: {
          title: MY_COVER.PREMIUM_CALCULATOR,
        },
      },
      {
        path: 'my-documents',
        name: MY_COVER_MY_DOCUMENTS,
        component: MyDocuments,
        meta: {
          title: MY_COVER.MY_DOCUMENTS.LANDING,
        },
      },
      {
        path: 'my-waiting-periods',
        name: WAITING_PERIODS,
        component: WaitingPeriod,
        meta: {
          title: MY_COVER.WAITING_PERIOD.LANDING,
        },
      },
      {
        path: 'change-my-cover',
        component: View,
        meta: {
          title: MY_COVER.CHANGE_COVER.LANDING,
        },
        children: [
          {
            path: '',
            name: CHANGE_MY_COVER,
            component: ChangeCoverLanding,
            meta: {
              title: MY_COVER.CHANGE_COVER.LANDING,
            },
          },
          // Change product flow routes
          {
            path: 'change-my-product',
            component: View,
            meta: {
              title: 'Change my product',
            },
            beforeEnter: changeCoverRouterGuard,
            children: [
              {
                path: ``,
                name: CHANGE_MY_PRODUCT,
                component: ChangeProductHome,
                props: () => getNavigationState(),
                meta: {
                  title: 'Change my product',
                },
              },
              {
                path: `product-selection`,
                name: PRODUCT_SELECTION,
                component: NewProductSelection,
                meta: {
                  title: 'Cover selection',
                },
              },
              {
                path: `capture-additional-information`,
                name: CAPTURE_ADDITIONAL_INFORMATION,
                component: ChangeProductCaptureInfo,
                meta: {
                  title: 'Capture additional information',
                },
              },
              {
                path: `keep-my-cover`,
                name: KEEP_MY_COVER,
                component: KeepMyCover,
                meta: {
                  title: 'Keep My Cover',
                },
                props: () => getNavigationState(),
                beforeEnter: (to) => {
                  if (peekNavigationState().isFromRecommendationsPage) {
                    // keep my cover page is only accessible when click "Keep my cover" button from recommendations page
                    return true;
                  } else {
                    return { name: CHANGE_MY_PRODUCT, params: { policyNumber: to.params.policyNumber } }; // if visiting directly via url, redirect to change product page
                  }
                },
              },
              {
                path: `${CHANGE_COVER_CONFIRMATION}`,
                name: CHANGE_COVER_CONFIRMATION,
                component: ChangeCoverConfirmation,
                meta: {
                  title: 'Change cover updated',
                },
                props: () => getNavigationState(), // this is required so that `flowName` prop is passed to ChangeCoverConfirmation.vue for prefill
              },
            ],
          },
          // Add remove person flow routes
          {
            path: 'add-remove-person',
            name: ADD_REMOVE_PERSON,
            component: AddRemovePersonHome,
            props: () => getNavigationState(),
            meta: {
              title: MY_COVER.CHANGE_COVER.ADD_REMOVE_PERSON,
            },
            beforeEnter: changeCoverRouterGuard,
          },
          {
            path: 'add-remove-person-success',
            name: ADD_REMOVE_PERSON_SUCCESS,
            component: AddRemovePersonSuccessConfirmation,
            props: () => getNavigationState(),
            beforeEnter: (to) => {
              const vuexState = JSON.parse(window.sessionStorage.getItem('vuex')).AddRemovePerson;
              if (peekNavigationState().productInfo || vuexState.submitPolicyInProcess) {
                // Add/remove Person Success page is only accessible after form submission(in which case `productInfo` param will exist) or submit policy in process error.
                return true;
              } else {
                return { name: ADD_REMOVE_PERSON, params: { policyNumber: to.params.policyNumber } }; // if visiting directly via url, redirect to add/remove person home page
              }
            },
          },
        ],
      },
      {
        path: 'change-my-excess',
        component: View,
        meta: {
          title: MY_COVER.CHANGE_EXCESS.LANDING,
        },
        children: [
          {
            path: '',
            name: CHANGE_EXCESS,
            component: ChangeExcess,
            props: true,
            meta: {
              title: MY_COVER.CHANGE_EXCESS.LANDING,
            },
          },
          {
            path: 'change-excess-premium-impact',
            name: CHANGE_EXCESS_PREMIUM_IMPACT,
            component: ChangeExcessPremiumImpact,
            props: () => getNavigationState(),
            meta: {
              title: MY_COVER.CHANGE_EXCESS.PREMIUM_IMPACT,
            },
            beforeEnter: (to) => {
              const vuexState = JSON.parse(window.sessionStorage.getItem('vuex')).ChangeExcess;
              if ((peekNavigationState().refData && peekNavigationState().newPremium) || vuexState.submitPolicyInProcess) {
                return true;
              } else {
                return { name: CHANGE_EXCESS, params: { policyNumber: to.params.policyNumber } };
              }
            },
          },
        ],
      },
      {
        path: 'rebate',
        component: View,
        meta: {
          title: 'Rebate',
        },
        children: [
          {
            path: '',
            name: REBATES_MEMBER_PORTAL.REBATE_OVERVIEW,
            component: RebateLanding,
            meta: {
              title: 'Rebate',
            },
          },
          {
            path: 'history',
            name: REBATES_MEMBER_PORTAL.REBATE_TIER_HISTORY,
            component: RebateTierHistory,
            meta: {
              title: 'Rebate tier history',
            },
            beforeEnter: rebatesRouterGuard,
          },
          {
            path: 'add',
            name: REBATES_MEMBER_PORTAL.ADD_REBATE,
            component: AddRebate,
            meta: {
              title: 'Add a rebate',
            },
            beforeEnter: rebatesRouterGuard,
          },
          {
            path: 'update',
            name: REBATES_MEMBER_PORTAL.UPDATE_REBATE,
            component: UpdateRebate,
            meta: {
              title: 'Update your rebate tier',
            },
            beforeEnter: rebatesRouterGuard,
          },
          {
            path: 'withdraw',
            name: REBATES_MEMBER_PORTAL.WITHDRAW_REBATE,
            component: WithdrawRebate,
            meta: {
              title: 'Withdraw your rebate',
            },
            beforeEnter: rebatesRouterGuard,
          },
          {
            path: 'success',
            name: REBATES_MEMBER_PORTAL.REBATE_UPDATE_SUCCESS,
            component: RebateUpdated,
            meta: {
              title: 'Rebate updated',
            },
            props: () => getNavigationState(),
            beforeEnter: rebatesRouterGuard,
          },
        ],
      },
    ],
  },
];
